export const API_KEY_STORE_KEY = 'apiKey';
export const API_KEY_SERVICE_KEY = 'apiKey';
export const API_KEY_API_URL = '/api/v1/api-key/';
